export default {
  mobile: 420,
  tablet: 768
};
